// import { STATION_LIST_ACTION } from '@constants/actions';
// import { routePath } from '@constants/path';

type TLifeTimeKeys = {
  [key: string]: Array<string>;
};

export default function getLifeTimeKeys(reduxActionName: string): Array<string> {
  const lifeTimeKeysObj: TLifeTimeKeys = {
    app: ['/'],
    // [STATION_LIST_ACTION]: [routePath.resource.station.path, routePath.resource.station.detail.path],
  };

  return lifeTimeKeysObj[reduxActionName] ?? [];
}
